"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDealerIdLocationEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const InventoryDealerIdLocationDto_1 = require("./InventoryDealerIdLocationDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class InventoryDealerIdLocationEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, inventoryDealerIdLocation) {
        super();
        this._requiredFieldsSetStatus = {
            inventoryDealerIdId: false,
            locationId: false
        };
        this._dependencies = dependencies;
        if (inventoryDealerIdLocation === undefined) {
            this._dto = new InventoryDealerIdLocationDto_1.InventoryDealerIdLocationDto();
        }
        else if (inventoryDealerIdLocation instanceof InventoryDealerIdLocationDto_1.InventoryDealerIdLocationDto) {
            this._dto = new InventoryDealerIdLocationDto_1.InventoryDealerIdLocationDto(inventoryDealerIdLocation);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.inventoryDealerIdId);
        }
        else if (inventoryDealerIdLocation instanceof InventoryDealerIdLocationEntity) {
            this._dto = new InventoryDealerIdLocationDto_1.InventoryDealerIdLocationDto(inventoryDealerIdLocation._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.inventoryDealerIdId);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new InventoryDealerIdLocationDto_1.InventoryDealerIdLocationDto(this._dto);
    }
    getInventoryDealerIdId() {
        return this._dto.inventoryDealerIdId;
    }
    setInventoryDealerIdId(untrustedValue) {
        let _untrustedValue;
        this.clearError("inventoryDealerIdId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("inventoryDealerIdId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.inventoryDealerIdId) {
            return;
        }
        this._dto.inventoryDealerIdId = _untrustedValue;
        this._setIsDirty(true);
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.inventoryDealerIdLocationDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Inventory Provider is not in a valid state.");
                }
                if (this.isNew) {
                    yield this._dependencies.inventoryDealerIdLocationDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    yield this._dependencies.inventoryDealerIdLocationDatastore
                        .updateAsync(this._dto);
                }
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Inventory Provider cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.inventoryDealerIdLocationDatastore
                        .removeAsync(this.getInventoryDealerIdId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.InventoryDealerIdLocationEntity = InventoryDealerIdLocationEntity;
//# sourceMappingURL=InventoryDealerIdLocationEntity.js.map